import { Fragment, useState } from 'react'
import {
  Space,
  Divider,
  Button,
  Tooltip,
  Typography,
  Input,
  Message,
  Dropdown,
  Menu,
  Empty
} from '@arco-design/web-react'
import styles from '../style/custom-filter.module.less'
import EchoModal from '@/components/EchoModal'
import { useUpdateEffect } from 'ahooks'
import { useRouter } from 'next/router'
import { cloneDeep } from 'lodash'
import { IconMoreVertical, IconEdit, IconDelete, IconDown } from '@arco-design/web-react/icon'
import useLocale from '@/utils/useLocale'
import useLocalStorageWithExpiry from '@/utils/useLocalStorageWithExpiry'

const { Text } = Typography

interface Props {
  params: any
  results?: any
  onChange: (params: any) => void
}

interface ITableItem {
  params: Record<string, any>
  results: any[]
  name: string
  key: string
}

export const CustomFilterSaveButton = ({
  params,
  results,
  saveSuccessCallback
}: {
  params: any
  results?: any
  saveSuccessCallback?: () => void
}) => {
  const t = useLocale()
  const router = useRouter()
  const [currentName, setCurrentName] = useState('')
  const [visible, setVisible] = useState(false)
  const [inputStatus, setInputStatus] = useState<any>(undefined)

  const [modalType, setModalType] = useState('new')
  const [currentResults, setCurrentResults] = useState<any[]>(results || [])
  const { getItemWithExpiry, setItemWithExpiry } = useLocalStorageWithExpiry({
    key: `${router.pathname}_custom_filter_list`,
    expiryInMinutes: null
  })
  const tableList = getItemWithExpiry() || []

  useUpdateEffect(() => {
    setCurrentResults(results)
  }, [results])

  const handleOk = () => {
    if (!currentName) {
      setInputStatus('error')
      Message.error(t['information.name'])
      return
    }
    if (results?.length === 0) {
      Message.error(t['filer_empty'])
      return
    }
    if (tableList.filter((item) => item.name === currentName).length > 0) {
      setInputStatus('error')
      Message.error(t['name_canot_repeated'])
      return
    }
    if (modalType === 'new') {
      const list = cloneDeep(tableList)
      list.push({
        params: params,
        results: results,
        name: currentName,
        key: currentName
      })
      setItemWithExpiry(list)
      Message.success(t['favorite.create_success'])
      setTimeout(() => {
        saveSuccessCallback?.()
      })
    }
    setVisible(false)
  }

  return (
    <>
      <Button
        style={{ borderRadius: 16 }}
        onClick={() => {
          setModalType('new')
          setCurrentName('')
          setVisible(true)
        }}
      >
        {t['save_current_filter']}
      </Button>
      <EchoModal
        visible={visible}
        onCancel={() => setVisible(false)}
        title={`${modalType === 'edit' ? t['monitor.btn.edit'] : t['userSetting.btn.save']}${t['current_filter']}`}
        onOk={handleOk}
      >
        <div>
          <div className={styles['modal-content-row']}>
            <label className={styles['modal-content-label']}>{t['common.filter.filtering']}:</label>
            <div className={styles['modal-content-result-list']}>
              {currentResults.map((result: any, index) => {
                return (
                  <Fragment key={index}>
                    <Text>{result.text}</Text>
                    {index === currentResults.length - 1 ? null : <Divider type="vertical" />}
                  </Fragment>
                )
              })}
            </div>
          </div>
          <div className={styles['modal-content-row']}>
            <label className={styles['modal-content-label']}>{t['filer_name']}:</label>
            <Input
              placeholder={t['custom_filter_placeholder']}
              style={{ width: 400 }}
              value={currentName}
              onChange={(v) => {
                setCurrentName(v)
              }}
              status={inputStatus}
            />
          </div>
        </div>
      </EchoModal>
    </>
  )
}

export const CustomFilterListButton = ({ params, results, onChange }: Props) => {
  const t = useLocale()
  const router = useRouter()
  const [currentName, setCurrentName] = useState('')
  const [visible, setVisible] = useState(false)
  const [delVisible, setDelVisible] = useState(false)
  const [inputStatus, setInputStatus] = useState<any>(undefined)
  const [modalType, setModalType] = useState('new')
  const [editData, setEditData] = useState<ITableItem>()
  const [currentResults, setCurrentResults] = useState<any[]>(results || [])
  const { getItemWithExpiry, setItemWithExpiry } = useLocalStorageWithExpiry({
    key: `${router.pathname}_custom_filter_list`,
    expiryInMinutes: null
  })
  const tableList = getItemWithExpiry() || []

  useUpdateEffect(() => {
    setCurrentResults(results)
  }, [results])

  // useUpdateEffect(() => {
  //   console.log('当前值', tableList)
  //   setTableList(cloneDeep(tableList))
  // }, [updateFlag])

  const handleOk = () => {
    if (!currentName) {
      setInputStatus('error')
      Message.error(t['information.name'])
      return
    }
    if (results?.length === 0) {
      Message.error(t['filer_empty'])
      return
    }
    if (tableList.filter((item) => item.name === currentName).length > 0) {
      setInputStatus('error')
      Message.error(t['name_canot_repeated'])
      return
    }
    if (modalType === 'new') {
      const list = cloneDeep(tableList)
      list.push({
        params: params,
        results: results,
        name: currentName,
        key: currentName
      })
      setItemWithExpiry(list)
      Message.success(t['favorite.create_success'])
    } else {
      const list = cloneDeep(tableList)
      const _index = list.findIndex((item) => item.key === editData?.key)
      if (_index > -1) {
        list[_index].name = currentName
        setItemWithExpiry(list)
        Message.success(t['edit_success'])
      }
    }
    setVisible(false)
  }

  const onClickMenuItem = (key: string, item: ITableItem) => {
    onChange?.(item.params)
  }

  const EditDropList = ({ data }: { data: ITableItem }) => {
    return (
      <Menu>
        <Menu.Item key="1">
          <div
            className={styles['drop-list-item']}
            onClick={() => {
              setModalType('edit')
              setEditData(data)
              setCurrentResults(data.results)
              setCurrentName(data.name)
              setVisible(true)
            }}
          >
            <IconEdit />
            <span>{t['rename']}</span>
          </div>
        </Menu.Item>
        <Menu.Item key="2">
          <div
            className={styles['drop-list-item']}
            onClick={() => {
              setModalType('edit')
              setEditData(data)
              setDelVisible(true)
            }}
          >
            <IconDelete />
            <span>{t['favorite.delete']}</span>
          </div>
        </Menu.Item>
      </Menu>
    )
  }

  const DropList = () => {
    return tableList.length === 0 ? (
      <div style={{ background: '#fff', padding: '10px 20px' }}>
        <Empty />
      </div>
    ) : (
      <Menu>
        {tableList.map((item) => {
          return (
            <Menu.Item key={item.name}>
              <div className={styles['drop-list-item']}>
                <div style={{ paddingRight: 20 }} onClick={() => onClickMenuItem(item.name, item)}>
                  {item.name}
                </div>
                <Dropdown droplist={<EditDropList data={item} />} trigger="hover">
                  <IconMoreVertical style={{ marginRight: 0 }} />
                </Dropdown>
              </div>
            </Menu.Item>
          )
        })}
      </Menu>
    )
  }

  return tableList.length === 0 ? null : (
    <div className={styles['custom-filter-wrap']}>
      <Dropdown droplist={<DropList />} trigger="click">
        <Button style={{ borderRadius: 8 }}>
          {t['quick_filer']}
          <IconDown />
        </Button>
      </Dropdown>
      <EchoModal
        visible={visible}
        onCancel={() => setVisible(false)}
        title={`${modalType === 'edit' ? t['monitor.btn.edit'] : t['userSetting.btn.save']}${t['current_filter']}`}
        onOk={handleOk}
      >
        <div>
          <div className={styles['modal-content-row']}>
            <label className={styles['modal-content-label']}>{t['common.filter.filtering']}:</label>
            <div className={styles['modal-content-result-list']}>
              {currentResults.map((result: any, index) => {
                return (
                  <>
                    <Text>{result.text}</Text>
                    {index === currentResults.length - 1 ? null : <Divider type="vertical" />}
                  </>
                )
              })}
            </div>
          </div>
          <div className={styles['modal-content-row']}>
            <label className={styles['modal-content-label']}>{t['filer_name']}:</label>
            <Input
              placeholder={t['custom_filter_placeholder']}
              style={{ width: 400 }}
              value={currentName}
              onChange={(v) => {
                setCurrentName(v)
              }}
              status={inputStatus}
            />
          </div>
        </div>
      </EchoModal>
      <EchoModal
        title={t['monitor.jump.tip']}
        visible={delVisible}
        onCancel={() => setDelVisible(false)}
        onOk={() => {
          const list = cloneDeep(tableList)
          const _index = list.findIndex((item) => item.key === editData?.key)
          if (_index > -1) {
            list.splice(_index, 1)
            setItemWithExpiry(list)
            Message.success(t['favorite.delete_success'])
          }
          setDelVisible(false)
        }}
      >
        {t['favorite.sure_delete']}
      </EchoModal>
    </div>
  )
}

